<div class="app-shell" [class.auth-layout]="isAuthPage()">
  @if (!isAuthPage()) {
    <app-sidebar></app-sidebar>
    <div class="app-main">
      <app-header></app-header>
      <main class="page-body">
        <router-outlet></router-outlet>
      </main>
    </div>
  } @else {
    <main class="auth-main">
      <router-outlet></router-outlet>
    </main>
  }

</div>

<app-alert-modal></app-alert-modal>